import { connect } from 'react-redux';
import ProductDetailModal from '../../../components/products/ProductDetailModal';
import {
  aislesLayout,
  searchReportOptions,
  searchProductInfo,
  searchProductInfoLoading,
  searchProductImages,
  searchProductBarcodeUrl,
} from 'core/selectors';
import { getProductsInfo, getLastCaptures } from 'core/slices/products';
import { getBarcode } from 'core/slices/images';
import { setReportParameters } from 'core/slices/search';
import { reportProduct } from 'core/slices/tasks_modification';
import { createAbort, ABORT_KEYS } from 'core/slices/utils/abortManager';

function fetchProductInfo({ item, ean }) {
  return async (dispatch) => {
    const signal = createAbort(ABORT_KEYS.PRODUCT_INFO);
    await dispatch(setReportParameters('item', item));
    await dispatch(setReportParameters('ean', ean));
    try {
      await Promise.all([
        dispatch(getProductsInfo(signal)),
        dispatch(getLastCaptures(signal)),
        dispatch(getBarcode(ean, signal)),
      ]);
    } catch (e) {
      if (e.name !== 'AbortError') throw e;
    }
  };
}

export default connect(
  (state) => ({
    aislesLayout: aislesLayout(state),
    reportOptions: searchReportOptions(state),
    productInfo: searchProductInfo(state),
    productInfoLoading: searchProductInfoLoading(state),
    productImages: searchProductImages(state),
    productBarcodeUrl: searchProductBarcodeUrl(state),
  }),
  {
    fetchProductInfo,
    reportProduct,
  },
)(ProductDetailModal);
